import Parse from 'parse'
const App = Parse.Object.extend('App')

const state = {
  title: 'REALGAME Online Battle',
  locale: 'ja',
}

const getters = {
  title: (state) => (app) => {
    const title = info.get('createdAt')
    return title
  }
}

const mutations = {
  setApp (state, app) {
    state.app = app
  },
  setTitle (state, title) {
    state.title = title
  },
  setLocatle (state, locale) {
    state.locale = locale
  },
}

const actions = {
  async getApp({ commit }) {
    let query = new Parse.Query(App)
    let app = await query.first()
    commit('setApp', app)
    commit('setTitle', app.get('title'))
    commit('setLocatle', app.get('locale'))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
